export enum YardManagementFlows {
  ContainersAllocationByFilter = 'ContainersAllocationByFilter',
  SingleContainerAllocation = 'SingleContainerAllocation',
}
